import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSecurityOperationContext } from '../context/SecurityOperationContext';
import { useImportFileTransfer } from '../context/ImportFileTransferContext';
import ImportColumnConfirmationDialog from '../components/ImportColumnConfirmationDialog';

export default function useImportColumnConfirmation(destination) {
    const { sessionScopeToken } = useSecurityOperationContext();
    const { transfer } = useImportFileTransfer();
    const [request, setRequest] = useState(null);
    const resolver = useRef(null);
    const settle = useCallback((value = null) => {
        resolver.current?.(value);
        resolver.current = null;
        setRequest(null);
    }, []);
    useEffect(() => {
        settle();
        return () => { resolver.current?.(null); resolver.current = null; };
    }, [sessionScopeToken, settle]);
    // Shows a column check; resolves with the user's choice, or null on cancel.
    // A file can be switched to the other import; a linked worksheet cannot.
    const confirmColumns = useCallback(({ review, sourceLabel, file = null }) => {
        resolver.current?.(null);
        return new Promise((resolve) => {
            resolver.current = resolve;
            setRequest({ review, sourceLabel, file });
        });
    }, []);
    const columnDialog = request && <ImportColumnConfirmationDialog
        key={request.sourceLabel}
        review={request.review}
        sourceLabel={request.sourceLabel}
        onClose={() => settle()}
        onConfirm={settle}
        onSwitch={transfer && request.file ? () => {
            const file = request.file;
            settle();
            transfer(destination === 'watchlist' ? 'portfolio' : 'watchlist', file);
        } : undefined}
    />;
    return { confirmColumns, columnDialog, cancelColumnConfirmation: settle };
}
